export default "__VITE_ASSET__17e65332__"